import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedOutUser } from './mockFullLoggedOutUser';

export const mockFullLoggedOutUserNoContactLinks: MockResponseConfig = {
  ...mockFullLoggedOutUser,
  UnifiedProfileQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          bio: "<p>Hi I'm an engineer.</p>",
          company: 'Nike',
          aaid: '62587f99fdb60b0069294184',
          linkedinUrl: null,
          accountInternalId: '541b9286-8563-4825-aae8-43e7e90fb493',
          location: 'Kansas, USA',
          products: 'halp',
          role: 'CEO',
          internalId: 'c34de571-576f-45e6-8c02-0917609af889',
          username: 'loggedoutnocontactlinks',
          websiteUrl: null,
          xUrl: null,
          youtubeUrl: null,
          isPrivate: false,
          isPersonalView: false,
          isLinkedView: false,
        },
        atlassianProducts: {
          __typename: 'UnifiedAtlassianProductConnection',
          edges: [
            {
              cursor: '12',
              node: {
                id: 'ari:cloud:unified-portable-profile::unified-atlassian-product/halp',
                productId: 'halp',
                title: 'Halp',
                type: 'category',
                viewHref: '/t5/Halp/ct-p/halp',
              },
            },
          ],
          totalCount: 1,
        },
      },
    },
  }),
};
